/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getOpenTimecardAndBreakForEmployee} from '../api'

 export const useQueryGetOpenTimecardAndBreakForEmployee = createReactQueryHook('getOpenTimecardAndBreakForEmployee', getOpenTimecardAndBreakForEmployee)
